import { useMemo } from "react";
import { View } from "react-native";
import { ActivityIcon } from "@shared/components/md-design-system/Icon/ActivityIcon";

interface IActivityIconBoxProps {
    activityType: string;
    activityName: string;
    size: number;
    glyphSize: number;
    color: string;
    backgroundColor?: string;
    borderRadius?: number;
    borderColor?: string;
    borderStyle?: 'solid' | 'dashed';
}

export const ActivityIconBox = ({
    activityType,
    activityName,
    size,
    glyphSize,
    color,
    backgroundColor,
    borderRadius = 0,
    borderColor,
    borderStyle = 'solid',
}: IActivityIconBoxProps) => {
    const boxStyle = useMemo(
        () => ({
            width: size,
            height: size,
            flexShrink: 0,
            borderRadius,
            backgroundColor,
            ...(borderColor ? { borderWidth: 1, borderColor, borderStyle } : {}),
        }),
        [size, borderRadius, backgroundColor, borderColor, borderStyle],
    );

    return (
        <View className="items-center justify-center" style={boxStyle}>
            <ActivityIcon activityType={activityType} activityName={activityName} size={glyphSize} color={color} />
        </View>
    );
};

export default ActivityIconBox;
